import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "component-container-max-height" }
const _hoisted_3 = {
  key: 0,
  class: "component-container"
}
const _hoisted_4 = {
  class: "component-container-main-view",
  style: {"display":"flex","align-items":"flex-start"}
}

import { computed } from 'vue';
import { onMounted } from 'vue';
import { useStore } from 'vuex';
import { watch } from 'vue';

import '@rednex/gateway_core/dayjs';
//### Function imports

//### Service imports
//--- Service imports

//### Model imports
import { SidePanelViewType } from '@rednex/gateway_core';
//--- Model imports

//### Component imports
import NavigationBar from '@/core/navigation-bar/navigation-bar.vue';
import Sidebar from '@/core/sidebar/sidebar.vue';
//--- Component imports

//### External Properties
//--- External Properties

//### Setup

export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

//### Function imports
const store = useStore();
//--- Setup

//### Store/Reactive Data
const extendedSearchComponentVisible = computed(() => store.getters.extendedSearchComponentVisible);
const inList = computed(() => store.getters.inList);
const isAuthenticated = computed(() => store.getters.isAuthenticated);
const isTabletDevice = computed(() => store.getters.isTabletDevice);
const menuExpanded = computed(() => store.getters.menuExpanded);
const sidepanel = computed(() => store.getters.sidepanel);
const themeMode = computed(() => store.getters.themeMode);
//--- Store/Reactive Data

//### Variables const let
let ctxExtendedSearch;
let ctxSidebar;
//--- Variables const let

//### Component Lifecycle
onMounted(() => {
  refreshTheme();
  watch(sidepanel, () => {
    ctxSidebar = sidepanel;
  });
});
//--- Component Lifecycle

//### Functions
function refreshTheme() {
  themeMode.value === 'dark' ? require('@content/scss/rs-theme/rs-theme-dark.scss') : require('@content/scss/rs-theme/rs-theme.scss');
}
//--- Functions

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(isAuthenticated.value ? (!_ctx.isPhoneDevice ? (menuExpanded.value ? 'menu-expanded-wrapper' : 'menu-hidden-wrapper') : '') : '')
    }, [
      (isAuthenticated.value)
        ? (_openBlock(), _createBlock(Sidebar, { key: 0 }))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: "main-components-container",
        style: _normalizeStyle(_ctx.isPhoneDevice ? 'height: calc(100vh - 5rem)' : '')
      }, [
        (isAuthenticated.value)
          ? (_openBlock(), _createBlock(NavigationBar, { key: 0 }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
          class: _normalizeClass(`main-component-view ${!isAuthenticated.value ? 'main-component-not-authenticated' : ''} ${_ctx.isPhoneDevice ? 'mt-0' : ''}`)
        }, [
          _createElementVNode("div", _hoisted_2, [
            (isAuthenticated.value && extendedSearchComponentVisible.value && inList.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_unref(ctxExtendedSearch))
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                style: _normalizeStyle(`width: ${
                  isTabletDevice.value && sidepanel.value && sidepanel.value && sidepanel.value.props?.sidePanelViewType === _unref(SidePanelViewType).MAINVIEW
                    ? 0
                    : sidepanel.value && sidepanel.value.props?.sidePanelViewType === _unref(SidePanelViewType).MAINVIEW
                    ? 100 - (sidepanel.value.props?.sidePanelWidthPct ? sidepanel.value.props?.sidePanelWidthPct : 30)
                    : 100
                }%; height: 100%;`)
              }, [
                _createVNode(_component_router_view)
              ], 4 /* STYLE */),
              (sidepanel.value && sidepanel.value.props?.sidePanelViewType === _unref(SidePanelViewType).MAINVIEW)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(`sidebar-container ${isTabletDevice.value ? '' : 'ml-3'}`),
                    style: _normalizeStyle(`width: ${
                  isTabletDevice.value ? 100 : sidepanel.value.props.sidePanelWidthPct ? sidepanel.value.props.sidePanelWidthPct : 30
                }%; max-height: 100%; overflow: auto; ${_ctx.isPhoneDevice ? 'background-color: var(--body-background-color);' : ''}`)
                  }, [
                    _createVNode(_unref(ctxSidebar))
                  ], 6 /* CLASS, STYLE */))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ], 2 /* CLASS */)
      ], 4 /* STYLE */)
    ], 2 /* CLASS */),
    _createVNode(_component_Toast, { baseZIndex: 10000 })
  ]))
}
}

})